import {create} from 'zustand';
import {OrganizerDto} from '../../generated/models/OrganizerDto';
import {createJSONStorage, persist} from 'zustand/middleware';

export const STORAGE_KEYS = {
  organizer: 'organizer-storage',
} as const;

export type StorageKeyType = keyof typeof STORAGE_KEYS;

export interface OrganizerStore {
  organizer: OrganizerDto | null;
  setOrganizer: (organizer: OrganizerDto) => void;
  clearOrganizer: () => void;
}

export const useOrganizerStore = create<OrganizerStore>()(
  persist(
    set => ({
      organizer: null,
      setOrganizer: (organizer: OrganizerDto) => set({organizer}),
      clearOrganizer: () => set({organizer: null}),
    }),
    {
      name: STORAGE_KEYS.organizer,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
